import React from 'react';
import { Col, Row, Glyphicon } from 'react-bootstrap';
import * as AuditFormat from './AuditFormat'

class AuditDetail extends React.Component {

    formatLines(part) {
        let lines = part.split("|");

        return lines.map((line, i) => {
            if (i > 0) {
                return (
                    <span key={i}><br />
                        <span style={{ fontSize: "10px", marginLeft: "20px" }}><Glyphicon glyph="one-fine-dot" /></span>
                        {AuditFormat.formatText(line)}
                    </span>)
            }
            else
            {
                return <span key={i}>{AuditFormat.formatText(line)}</span>
            }
        })
    }

    render() {
        const changes = this.props.changeList.map((item, index) =>
            <Row key={index}>
                <Col md={12}>
                    <span style={{ fontSize: "10px" }}><Glyphicon glyph="arrow-right" /></span>
                    <span style={{ marginLeft: "10px" }}>{this.formatLines(item)}</span>
                </Col>
            </Row>
        )

        return (
            <div style={{ marginLeft: "50px", marginTop: "10px" }}>
                {changes}
            </div>
        );
    }
}

export default AuditDetail;



// WEBPACK FOOTER //
// ./src/areas/shared/components/audit/AuditDetail.js